import React from "react";
import CTAButton from "./Button";
import { FaArrowRight } from "react-icons/fa";

const CodeBlocks = ({
  position,
  heading,
  subheading,
  ctabtn1,
  ctabtn2,
  gifSrc,               
  backgroundGradient,
}) => {
  return (
    <div className={`flex ${position} my-20 justify-between flex-col lg:gap-10 gap-10 ring-richblack-900`}>
      
      {/* Section 1 */}
      <div className="w-[100%] lg:w-[50%] flex flex-col gap-8 text-richblack-900">
        {heading}

        {/* Sub Heading */}
        <div className="text-richblack-700 dark:text-richblack-100 text-lg font-bold w-[85%] -mt-3">
          {subheading}
        </div>
        

        {/* Button Group */}
        <div className="flex gap-7 mt-7 text-lg">
          <CTAButton active={ctabtn1.active} linkto={ctabtn1.link}>
            <div className="flex items-center gap-2">
              {ctabtn1.btnText}
              <FaArrowRight />
            </div>
          </CTAButton>
          <CTAButton active={ctabtn2.active} linkto={ctabtn2.link}>
            {ctabtn2.btnText}
          </CTAButton>
        </div>
      </div>

      {/* Section 2 */}
      <div className="h-fit code-border flex flex-row py-3 relative w-[100%] lg:w-[470px] bg-richblack-500 dark:bg-richblack-400 rounded-2xl overflow-hidden shadow-lg">
        {backgroundGradient}

        {/* GIF Display Only */}
        <div className="w-full flex items-center justify-center p-2">
          <img 
            src={gifSrc} 
            alt="Medical Animation" 
            className="w-full h-full object-contain rounded-lg"
          />
        </div>
      </div>
      {/* section-3 */}
      
    </div>
  );
};

export default CodeBlocks;
